import { render, staticRenderFns } from "./RegisterTab.vue?vue&type=template&id=feffdb66&scoped=true&"
import script from "./RegisterTab.vue?vue&type=script&lang=js&"
export * from "./RegisterTab.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTab.vue?vue&type=style&index=0&id=feffdb66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feffdb66",
  null
  
)

export default component.exports